module.exports = __webpack_public_path__ + "img/no-search.33f3fd3e.svg";